import { Component, OnInit, ViewEncapsulation, Inject } from "@angular/core";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import textConfiguration from "../../../../assets/static-text-configuration.json";

export interface StatusUpdatePopupData {
  action: "Cancel" | "Close";
  module?: "assessment" | "audit";
}

@Component({
  selector: "status-update-popup",
  templateUrl: "./status-update-popup.component.html",
  styleUrls: ["./status-update-popup.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class StatusUpdatePopupComponent implements OnInit {
  buttonsText: any = (textConfiguration as any).buttons;
  modalPopUpText: any = (textConfiguration as any).modal_popup;

  actionLabel = "";
  moduleLabel = "Audit";
  confirmationWarning = "";

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<StatusUpdatePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public popupData: StatusUpdatePopupData
  ) {
    dialogRef.disableClose = true;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.hasBackdrop = true;
  }

  ngOnInit(): void {
    if (this.popupData) {
      this.actionLabel = this.popupData.action;
      
      const moduleType = (this.popupData.module || "audit").toLowerCase();
      this.moduleLabel = moduleType === "assessment" ? "Assessment" : "Audit";
      
      const moduleNameLower = this.moduleLabel.toLowerCase();
      const pastTense = this.popupData.action === "Cancel" ? "cancelled" : "closed";

      this.confirmationWarning = `Are you sure you want to <strong>${this.actionLabel.toLowerCase()}</strong> this ${moduleNameLower}? The ${moduleNameLower} response will become <strong>uneditable</strong> once it is ${pastTense}.`;
    }
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}